function isPlantNewEwoFeatures(plantDesc) {
  const plants = ['ZEDELGEM'];
  return plants.includes(plantDesc);
}

function zedelgemCondition(user) {
  return user.plantdesc === 'ZEDELGEM' && [1, 4, 5, 8].includes(user.idprofilo);
}

function ModenaCondition(user) {
  return user.plantdesc === 'MODENA';
}

function ModenaBrekdowntype(value, user) {
  if (!ModenaCondition(user)) return value;
  const map = {
    '1 Partial': '1 Macchina Lavora',
    '2 Total': '2 Macchina Ferma'
  };
  return map[value] || value;
}

export { isPlantNewEwoFeatures, zedelgemCondition, ModenaCondition, ModenaBrekdowntype };